import { ProductBuilderMachineState } from '../types';
import { productHelpTextConfig } from '../constants/productHelpTextConfig';

type GetStateKey = (
  productType: string | void,
  stateName: ProductBuilderMachineState,
) => string | void;

export const getProductHelpTextConfig: GetStateKey = (
  productType,
  stateName,
) => {
  if (!productType) return;
  return productHelpTextConfig[productType][stateName] || '';
};
